import React from 'react';

/**
 * Button Component - 2025 Design System (iOS-style)
 *
 * Production-grade button with:
 * - Active scale transform
 * - Smooth transitions
 * - Semantic variants
 * - Hover states with depth
 */

export const Button = ({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  disabled = false,
  ...props
}) => {
  const variants = {
    primary: `
      bg-blue-500 hover:bg-blue-600 active:bg-blue-700
      text-white
      shadow-sm hover:shadow
    `,
    secondary: `
      bg-gray-100 hover:bg-gray-200 active:bg-gray-300
      text-gray-900
      border border-gray-300
    `,
    success: `
      bg-green-500 hover:bg-green-600 active:bg-green-700
      text-white
      shadow-sm hover:shadow
    `,
    danger: `
      bg-red-500 hover:bg-red-600 active:bg-red-700
      text-white
      shadow-sm hover:shadow
    `,
    ghost: `
      bg-transparent hover:bg-gray-100 active:bg-gray-200
      text-gray-700
    `,
    link: `
      bg-transparent hover:bg-blue-50 active:bg-blue-100
      text-blue-600
    `,
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
  };

  return (
    <button
      className={`
        inline-flex
        items-center
        justify-center
        gap-2
        rounded-lg
        font-medium
        transition-all
        duration-200
        ease-out
        active:scale-95
        disabled:opacity-50
        disabled:cursor-not-allowed
        disabled:active:scale-100
        focus:outline-none
        focus:ring-2
        focus:ring-blue-500
        focus:ring-offset-2
        ${variants[variant] || variants.primary}
        ${sizes[size] || sizes.md}
        ${className}
      `}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};
